// import axios from 'axios'

// export default axios.create({
//     baseURL: '',
//     timeout: 10000
// })


import axios from 'axios'

// 创建axios实例
let service = axios.create({
    baseURL: "http://112.124.106.58:9000/", // api的base_url
    timeout: 15000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
    //   if (store.getters.token) {
    //     config.headers = {
    //       'Authorization' : "Token " + getToken('Token'), //携带权限参数
    //      };
    //   }
    console.log("测试");
    console.log(config);
    return config
}, error => {
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code:200,接口正常返回;
         */
        const res = response.data;
        console.log(res);
        if (res.code !== 200) {
            console.log("失败");
        } else { // res.code === 200,正常返回数据
            // return response.data
            console.log("成功")
        }
        return res;
    },
    error => {
        console.log(error);
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/api/index.js